import { render, staticRenderFns } from "./InsuranceFamily.vue?vue&type=template&id=6836f14e&"
import script from "./InsuranceFamily.vue?vue&type=script&lang=js&"
export * from "./InsuranceFamily.vue?vue&type=script&lang=js&"
import style0 from "./InsuranceFamily.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports